import React, { useState, useEffect, useRef } from "react";
import {
  Container, Box, Grid, TextField, Button, Typography, Checkbox, Link, Modal, IconButton, InputAdornment,
} from "@mui/material";
import hostel2 from "../assets/Images/hostel2.jpg";
import logo from "../assets/Images/Clanbridge-logo.png2.png";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../lib/axios";
import AuthHeader from "../Auth";
import axiosInstance from "../lib/axios";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../redux/userSlice";
import OtpModal from "../Components/ResidentLogin/Login/OtpModal";
import ForgotPasswordModal from "../Components/ResidentLogin/Login/ForgotPwdModal";
import InputMobileModal from "../Components/ResidentLogin/Login/InputMobModal";
import { NUMBER_REGEX, PHONE_REGEX } from "../lib/regex";

const STORAGE_KEYS = {
  USERNAME: 'saved_username',
  PASSWORD: 'saved_password',
  LOGIN_METHOD: 'saved_login_method',
  MOBILE_NUMBER: 'saved_mobile_number',
  EXPIRY: 'credentials_expiry',
  KEEP_LOGGED_IN: 'keep_me_logged_in'
};

const ONE_WEEK = 7 * 24 * 60 * 60 * 1000;

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [number, setNumber] = useState("");
  const [loginMethod, setLoginMethod] = useState("userId");
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isInputMobModalOpen, setIsInputMobModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalFgtOpen, setIsModalFgtOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [isMobileValid, setIsMobileValid] = useState(true);
  const [firstName, setFirstName] = useState("");
  const [residentData, setResidentData] = useState(null);
  const [generatedOtp, setGeneratedOtp] = useState("");
  const [generatedFgtOtp, setGeneratedFgtOtp] = useState("");
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [isOtpMismatch, setIsOtpMismatch] = useState(false);
  const [verifiedMobileNumber, setVerifiedMobileNumber] = useState("");
  const [otp, setOtp] = useState(Array(4).fill(""));
  const [passwordError, setPasswordError] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [residentId, setResidentId] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showResidentPwd, setShowResidentPwd] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isForgotPasswordModalOpen, setIsForgotPasswordModalOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [keepMeLoggedIn, setKeepMeLoggedIn] = useState(false);
  const newPasswordRef = useRef(null);

  // const USERID_REGEX = /^[A-Za-z_-]*$/;
  const USERID_REGEX = /^[A-Za-z0-9_@.-\s]*$/;

 useEffect(() => {
  const autoLogin = async () => {
    const savedKeepLoggedIn = localStorage.getItem(STORAGE_KEYS.KEEP_LOGGED_IN);
    const expiryTime = localStorage.getItem(STORAGE_KEYS.EXPIRY);
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
    
    console.log("Auto-login check:", { savedKeepLoggedIn, expiryTime, isLoggedIn });
    
    if (savedKeepLoggedIn === 'true' && expiryTime && isLoggedIn) {
      const now = new Date().getTime();
      
      if (now < parseInt(expiryTime)) {
        const savedLoginMethod = localStorage.getItem(STORAGE_KEYS.LOGIN_METHOD);
        const savedPassword = localStorage.getItem(STORAGE_KEYS.PASSWORD);
        
        console.log("Auto-login method:", savedLoginMethod);
        
        if (savedLoginMethod === 'userId') {
          const savedUsername = localStorage.getItem(STORAGE_KEYS.USERNAME);
          console.log("Saved username:", savedUsername);
          
          if (savedUsername && savedPassword) {
            // Check if already on dashboard to prevent infinite loop
            const currentPath = window.location.pathname;
            if (currentPath === '/dashboard' || currentPath === '/residentmenu' || currentPath === '/serviceprov-portal') {
              return;
            }
            
            // Auto login for userId
            setIsLoading(true);
            try {
              const trimmedUserId = savedUsername.trim().toLowerCase();
              const trimmedPassword = savedPassword.trim();
              
              // Check for sp_admin
              if (trimmedUserId === "sp_admin" && trimmedPassword === "admin") {
                dispatch(login({
                  UserId: "sp_admin",
                  UserName: "admin",
                  MobileNo: "",
                  Email: "",
                }));
                
                localStorage.setItem("userName", "admin");
                sessionStorage.setItem("UserName", "admin");
                sessionStorage.setItem("loginType", "userId");
                sessionStorage.setItem("isLoggedIn", "true");
                sessionStorage.setItem("UserId", "sp_admin");
                sessionStorage.setItem("UtId", "1");
                
                navigate("/serviceprov-portal");
                return;
              }
              
              // Regular user login
              let EncrpytData = await handleEncrpytAuto(savedPassword);
              
              const response = await axios.post(
                `${process.env.REACT_APP_API_URL}Login/UserMst/GetuserLogin`,
                {
                  Username: savedUsername,
                  Pwd: EncrpytData,
                },
                AuthHeader()
              );
              
              if (response.data.Status === 0) {
                const data = response.data.Data;
                
                dispatch(login({
                  UserId: data?.UserId,
                  UserName: data?.UserName,
                  MobileNo: data?.MobileNo,
                  Email: data?.EmailId,
                }));
                
                sessionStorage.setItem("UserName", data?.UserName);
                sessionStorage.setItem("loginType", "userId");
                sessionStorage.setItem("mobileNumber", data?.MobileNo);
                sessionStorage.setItem("isLoggedIn", "true");
                sessionStorage.setItem("UserId", data?.UserId);
                sessionStorage.setItem("UtId", data?.UtId);
                sessionStorage.setItem("UtType", data?.UtType);
                
                navigate("/dashboard");
              }
            } catch (error) {
              console.error("Auto-login failed:", error);
            } finally {
              setIsLoading(false);
            }
          }
        } 
        else if (savedLoginMethod === 'mobile') {
          const savedMobile = localStorage.getItem(STORAGE_KEYS.MOBILE_NUMBER);
          console.log("Saved mobile:", savedMobile);
          
          if (savedMobile && savedPassword) {
            const currentPath = window.location.pathname;
            if (currentPath === '/residentmenu') {
              return;
            }
            
            setIsLoading(true);
            try {
              let EncrpytData = await handleEncrpytAuto(savedPassword);
              
              const response = await axiosInstance.post(`ResidentMst/ResidentLogin`, {
                Mobile: savedMobile,
                Pwd: EncrpytData,
                Flag: "Auth",
                ResidentId: 1,
              });
              
              if (response.data.Status === 0 && Array.isArray(response.data.Data)) {
                const residentData = response.data.Data[0];
                
                localStorage.setItem("RoomBedId", residentData.RoomBedId);
                localStorage.setItem("ResidentId", residentData.ResidentId);
                localStorage.setItem("ResidentName", residentData.FirstName);
                localStorage.setItem("PropertyId", residentData.PropId);
                
                sessionStorage.setItem("UserId", response.data.Data.UserId);
                sessionStorage.setItem("UtId", response.data.Data.UtId);
                sessionStorage.setItem("isLoggedIn", "true");
                
                navigate("/residentmenu");
              }
            } catch (error) {
              console.error("Auto-login failed:", error);
            } finally {
              setIsLoading(false);
            }
          }
        }
      } else {
        // Expired, clear everything
        clearSavedCredentials();
        localStorage.removeItem("isLoggedIn");
        sessionStorage.clear();
      }
    }
  };
  
  autoLogin();
}, []);

const handleEncrpytAuto = async (pwd) => {
  if (!pwd) return "";
  try {
    const response = await axiosInstance.post(`UserMst/Getpwdencryption`, {
      Pwd: pwd,
    });
    if (response.data.Status === 0) {
      return response.data.Data;
    } else {
      return response.data.Data;
    }
  } catch (error) {
    console.error("Encryption error:", error);
    return "";
  }
};

  const clearSavedCredentials = () => {
    localStorage.removeItem(STORAGE_KEYS.USERNAME);
    localStorage.removeItem(STORAGE_KEYS.PASSWORD);
    localStorage.removeItem(STORAGE_KEYS.LOGIN_METHOD);
    localStorage.removeItem(STORAGE_KEYS.MOBILE_NUMBER);
    localStorage.removeItem(STORAGE_KEYS.EXPIRY);
    localStorage.removeItem(STORAGE_KEYS.KEEP_LOGGED_IN);
  };

  const saveCredentials = (method, usernameOrMobile, password) => {
    if (!keepMeLoggedIn) return;

    const expiryTime = new Date().getTime() + ONE_WEEK;

    localStorage.setItem(STORAGE_KEYS.LOGIN_METHOD, method);
    localStorage.setItem(STORAGE_KEYS.PASSWORD, password);
    localStorage.setItem(STORAGE_KEYS.EXPIRY, expiryTime.toString());
    localStorage.setItem(STORAGE_KEYS.KEEP_LOGGED_IN, 'true');

    if (method === 'userId') {
      localStorage.setItem(STORAGE_KEYS.USERNAME, usernameOrMobile);
      localStorage.removeItem(STORAGE_KEYS.MOBILE_NUMBER);
    } else if (method === 'mobile') {
      localStorage.setItem(STORAGE_KEYS.MOBILE_NUMBER, usernameOrMobile);
      localStorage.removeItem(STORAGE_KEYS.USERNAME);
    }
     localStorage.setItem("isLoggedIn", "true");
  };

  const handleKeepMeLoggedInChange = (e) => {
    const isChecked = e.target.checked;
    setKeepMeLoggedIn(isChecked);

    if (!isChecked) {
      clearSavedCredentials();
    }
  };

  // Inside the Login component, update the handleUserIdChange function
  const handleUserIdChange = (e) => {
    const value = e.target.value;
    if (USERID_REGEX.test(value)) {
      setUserId(value);
    }
  };

  const handleMobileInputChange = async (e) => {
    const mobileNumber = e.target.value;

    if (/^\d{0,10}$/.test(mobileNumber)) {
      setNumber(mobileNumber);

      if (mobileNumber.length === 10) {
        try {
          const response = await axiosInstance.post(
            `ResidentMst/ResidentLogin`,
            {
              Mobile: mobileNumber,
              Pwd: "",
              Flag: "",
              ResidentId: 1,
            }
          );
          const { data: { Status, Data } } = response;
          if (Status === 0) {
            const residentData = Data[0];
            setResidentData(residentData);
            setResidentId(residentData.ResidentId);

            setEmail(residentData.Email); // Ensure this is set correctly

            if (!residentData.Pwd && !residentData.RoomBedId) {
              // Both Pwd and RoomBedId are null
              setIsMobileValid(false);
              setEmail(residentData.Email);
              setMessage("Unauthorized User");
            } else if (!residentData.Pwd && residentData.RoomBedId) {
              // Pwd is null but RoomBedId has a value
              setIsMobileValid(false);
              setEmail(residentData.Email);
              setMessage("New User");
              toast.info("You are a new user. Please create a password to continue.", {
                position: "top-right",
                autoClose: 4000,
              });
            } else {
              // Valid user
              setIsMobileValid(true);
            }
          } else if (Status === 1) {
            // When status is 1, set the message to "Invalid user"
            setIsMobileValid(false);
            setEmail(""); // Clear email since it's not applicable
          } else {
            console.error("API Error:", response.data.Message);
          }
        } catch (error) {
          toast.error("Error fetching mobile data:", error);
        }
      } else {
        setIsMobileValid(true);
      }
    }
  };

  const handleMobileLogin = async () => {
    if (isLoading) return;
    // Validation for empty fields in mobile login
    if (!number.trim() && !password.trim()) {
      toast.error("Please enter Mobile Number and Password.", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }
    if (!/^\d{10}$/.test(number.trim())) {
      toast.error("Please enter a valid 10-digit Mobile Number.", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }
    if (!password.trim()) {
      toast.error("Please enter your Password.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }
    // Check if user is new and password is not set
    if (message === "New User" || (residentData && !residentData.Pwd)) {
      toast.error("You are a new user. Please create a password before logging in.", {
        position: "top-right",
        autoClose: 3000,
      });
      return; // Prevent login attempt
    }

    let EncrpytData = await handleEncrpyt();
    setIsLoading(true);
    if (EncrpytData === "") {
      toast.error("Something Went Wrong!!");
      return;
    }

    setIsLoading(true);
    try {
      const response = await axiosInstance.post(`ResidentMst/ResidentLogin`, {
        Mobile: number,
        Pwd: EncrpytData,
        Flag: "Auth",
        ResidentId: residentId,
      });

      const { data: { Status, Data, Message }, } = response;

      if (Status === 0 && Array.isArray(Data)) {
        const residentData = Data[0];
        const RoomBedId = residentData.RoomBedId; // Get RoomBedId
        localStorage.setItem("RoomBedId", RoomBedId); //
        const RoomBedName = residentData.RoomBedName; // Get RoomBedId
        localStorage.setItem("RoomBedName", RoomBedName); //
        const ResidentName = residentData.FirstName || number;
        setFirstName(residentData.FirstName);
        const ResidentId = residentData.ResidentId;
        localStorage.setItem("ResidentId", ResidentId);
        localStorage.setItem("ResidentName", residentData.FirstName);
        localStorage.setItem("PropertyId", residentData.PropId);
        localStorage.setItem("Mobile", residentData.Mobile);

        if (keepMeLoggedIn) {
          saveCredentials('mobile', number, password);
        }
        localStorage.setItem("isLoggedIn", "true");

        toast.success("Login Successfully", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setTimeout(() => {
          navigate("/residentmenu");
        }, 2000);
        sessionStorage.setItem("UserId", response.data.Data.UserId);
        sessionStorage.setItem("UtId", response.data.Data.UtId);
      } else {
        toast.error("Invalid Login Credentials" || Message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } catch (error) {
      toast.error("An error occurred during login.", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleValidateMobile = async () => {
    setIsModalOpen(true);
    await handleSendOtp();
  };

  const handleSendOtp = async () => {
    if (!residentData || !residentData.PropId) {
      toast.error("Property ID is missing. Cannot send OTP.");
      return;
    }
    try {
      const otpResponse = await axiosInstance.post(
        `EmailRequest/OtpGenerate`, {}
      );

      if (otpResponse.data.Status === 0) {
        const otpMessage = otpResponse.data.Data;
        const otpMatch = otpMessage.match(/(\d{4})/);

        if (otpMatch && otpMatch[0]) {
          const otp = otpMatch[0];
          setGeneratedOtp(otp);

          const emailResponse = await axiosInstance.post(
            `EmailRequest/SendEmail`,
            {
              PropId: residentData.PropId,
              UserId: 1,
              ToEmail: [email],
              Subject: "Your OTP Code",
              Body: `Your OTP is ${otp}`,
              DocAttachments: [],
            }
          );

          if (emailResponse.data.Status === 0) {
            setIsOtpSent(true);
            setIsModalOpen(true);
          } else {
            toast.error("Failed to send OTP: " + emailResponse.data.Message);
          }
        } else {
          toast.error("Failed to extract OTP from response.");
        }
      } else {
        toast.error("Failed to generate OTP: " + otpResponse.data.Message);
      }
    } catch (error) {
      toast.error("An error occurred while sending OTP.");
    }
  };

  const handleForgotSendOtp = async () => {
    // if (!residentData || !residentData.PropId) {
    //   toast.error("Property ID is missing. Cannot send OTP.");
    //   return;
    // }
    try {
      const otpResponse = await axiosInstance.post(`EmailRequest/OtpGenerate`, {});

      if (otpResponse.data.Status === 0) {
        const otpMessage = otpResponse.data.Data;
        const otpMatch = otpMessage.match(/(\d{4})/);

        if (otpMatch && otpMatch[0]) {
          const otp = otpMatch[0];
          setGeneratedFgtOtp(otp);

          const emailResponse = await axiosInstance.post(
            `EmailRequest/SendEmail`,
            {
              PropId: residentData.PropId,
              UserId: 1,
              ToEmail: [email],
              Subject: "Your OTP Code",
              Body: `Your OTP is ${otp}`,
              DocAttachments: [],
            }
          );

          if (emailResponse.data.Status === 0) {
            setIsOtpSent(true);
            setIsModalFgtOpen(true);
          } else {
            toast.error("Failed to send OTP: " + emailResponse.data.Message);
          }
        } else {
          toast.error("Failed to extract OTP from response.");
        }
      } else {
        toast.error("Failed to generate OTP: " + otpResponse.data.Message);
      }
    } catch (error) {
      toast.error("An error occurred while sending OTP.");
    }
  };

  const handleToggleForgotModal = async () => {

    if (loginMethod === 'mobile') {
      // Check if the mobile number is empty
      if (number.trim() === "") {
        toast.error("Please enter your mobile number before clicking on Forgot Password.", { autoClose: 1000 });
        return;
      }

      const isValidMobile = /^\d{10}$/.test(number);
      if (!isValidMobile) {
        toast.error("Please type a valid mobile number.", { autoClose: 1000 });
        return;
      } if (isMobileValid) {
        await handleForgotSendOtp();
        setIsForgotPasswordModalOpen(!isForgotPasswordModalOpen);
      } else {
        toast.error("Please type a valid mobile number.", { autoClose: 1000 });
      }
    }
  };

  const handleToggleInputModal = async () => {
    setIsInputMobModalOpen(true);

    if (loginMethod === 'userId') {
      const isValidMobile = /^\d{10}$/.test(number);
      if (!isValidMobile) {
        return;
      }

      if (isMobileValid) {
        try {
          await handleForgotSendOtp();
          setIsInputMobModalOpen(false);
        } catch (error) {
          toast.error("Failed to send OTP. Please try again.", { autoClose: 1000 });
        }
      } else {
        toast.error("Please type a valid mobile number.", { autoClose: 1000 });
      }
    }
  };

  const handleEncrpyt = async () => {
    if (!password) {
      return "";
    }

    try {
      const response = await axiosInstance.post(`UserMst/Getpwdencryption`, {
        Pwd: password,
      });
      if (response.data.Status === 0) {
        return response.data.Data;
      } else {
        return response.data.Data;
      }
    } catch (error) { }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    // Reset OTP state
    setOtp(Array(4).fill(""));
    setIsOtpVerified(false);
    setNewPassword("");
    setConfirmPassword("");
  };

  const handleCloseFgtModal = () => {
    setIsModalFgtOpen(false);
    // Reset OTP state
    setOtp(Array(4).fill(""));
    setIsOtpVerified(false);
    setNewPassword("");
    setConfirmPassword("");
  };

  const handleCloseInputMobModal = () => {
    setIsInputMobModalOpen(false);
  };

  const checkPasswordMatch = (confirmPassword) => {
    if (newPassword && confirmPassword) {
      if (confirmPassword !== newPassword) {
        setPasswordError("Passwords do not match.");
      } else {
        setPasswordError("");
      }
    } else {
      setPasswordError("");
    }
  };

  const handleCreatePassword = async () => {
    if (!newPassword || !confirmPassword) {
      toast.error("Please fill in all fields.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setPasswordError("Passwords do not match.");
      return;
    }
    try {
      const response = await axiosInstance.post(
        `ResidentMst/InsertResidentLogin`,
        {
          Mobile: verifiedMobileNumber,
          Pwd: newPassword,
          Flag: "",
          ResidentId: residentData.ResidentId,
        }
      );

      const { data: { Status, Message } } = response;
      if (Status === 0 && Message) {
        toast.success(Message, { autoClose: 1000 });
        setIsModalOpen(false);
        setIsMobileValid(true);

        // Reset message state to clear "New User" status
        setMessage("");
        // Update residentData.Pwd to indicate password is now set
        setResidentData(prev => ({
          ...prev,
          Pwd: "set", // or any non-null value to indicate password exists
        }));
      } else {
        toast.error(response.data.Message);
      }
    } catch (error) {
      toast.error("An error occurred while creating the password.");
    }
  };

  // for forgot pwd
  const handleCreateNewPwd = async () => {
    if (!newPassword || !confirmPassword) {
      toast.error("Please fill in all fields.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setPasswordError("Passwords do not match.");
      return;
    }
    try {
      const response = await axiosInstance.post(
        `ResidentMst/InsertResidentLogin`,
        {
          Mobile: number, // Use the mobile number from the input
          Pwd: newPassword,
          Flag: "",
          ResidentId: residentData.ResidentId,
        }
      );

      const { data: { Status, Message }, } = response;
      if (Status === 0 && Message) {
        toast.success(Message, { autoClose: 1000 });
        setNewPassword("");
        setConfirmPassword("");
        setPasswordError("");
        setIsOtpVerified(false);
        setIsOtpMismatch(false);
        setOtp(Array(4).fill("")); // Reset OTP input
        setIsModalFgtOpen(false);
        setIsMobileValid(true);
      } else {
        console.error("Failed to create password: ", Message);
      }
    } catch (error) {
      toast.error("An error occurred while creating the password.", error);
    }
  };

  const setUserState = (user) => {
    dispatch(login(user));
  }

  const handleLogin = async () => {
    if (isLoading) return;
    // Validation for empty fields in userId login
    if (loginMethod === "userId") {
      if (!userId.trim() && !password.trim()) {
        toast.error("Please enter User Name and Password.", {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        return;
      }
      if (!password.trim()) {
        toast.error("Please enter your Password.", {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        return;
      }
    }
    // Hardcoded special login for sp_admin
    const trimmedUserId = userId.trim().toLowerCase();
    const trimmedPassword = password.trim();

    if (trimmedUserId === "sp_admin" && trimmedPassword === "admin") {
      setIsLoading(true);
      try {
        const mockData = {
          UserId: "sp_admin",
          UserName: "admin",
          MobileNo: "", // Optional, can set if needed
          EmailId: "", // Optional, can set if needed
          UtId: 1, // Mock UtId
          loginMethod: "userId", // Mock login type
        };

        if (keepMeLoggedIn) {
           saveCredentials('userId', userId, password);
        }
        sessionStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("isLoggedIn", "true")

        // Set Redux state
        setUserState({
          UserId: mockData.UserId,
          UserName: mockData.UserName,
          MobileNo: mockData.MobileNo,
          Email: mockData.EmailId,
        });

        // Set localStorage
        const userName = mockData.UserName || trimmedUserId;
        localStorage.setItem("userName", userName);
        localStorage.setItem("isLoggedIn", "true");
        // Set sessionStorage
        sessionStorage.setItem("UserName", mockData.UserName); // Fixed key to match convention
        sessionStorage.setItem("loginType", mockData.loginMethod);
        sessionStorage.setItem("mobileNumber", mockData.MobileNo);
        sessionStorage.setItem("isLoggedIn", "true");
        sessionStorage.setItem("UserId", mockData.UserId); // Fixed key to match convention
        sessionStorage.setItem("UtId", String(mockData.UtId)); // Ensure UtId is stored as string

        toast.success("Login Successfully", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          onClose: () => {
            navigate("/serviceprov-portal");
          },
        });
      } catch (error) {
        toast.error("An error occurred during login.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } finally {
        setIsLoading(false);
      }
      return; // Exit early to skip API call for sp_admin
    }

    let EncrpytData = await handleEncrpyt();
    setIsLoading(true);
    if (EncrpytData === "") {
      toast.error("Something Went Wrong!!");
      return;
    }
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}Login/UserMst/GetuserLogin`,
        {
          Username: userId,
          Pwd: EncrpytData,
        },
        AuthHeader()
      );
      if (response.data.Status === 0) {
        const data = response.data.Data

        if (keepMeLoggedIn) {
          saveCredentials('userId', userId, password);
        }

        setUserState({
          UserId: data?.UserId,
          UserName: data?.UserName,
          MobileNo: data?.MobileNo,
          Email: data?.EmailId,
        });
        const userName = response.data.userName || userId;
        localStorage.setItem("userName", userName);
        localStorage.setItem("isLoggedIn", "true");
        sessionStorage.setItem("UserName", response.data.Data.UserName);
        sessionStorage.setItem("loginType", response.data.Data.loginMethod);
        sessionStorage.setItem("mobileNumber", response.data.Data.MobileNo);
        sessionStorage.setItem("isLoggedIn", "true");
        sessionStorage.setItem("UserId", response.data.Data.UserId);
        sessionStorage.setItem("UtId", response.data.Data.UtId);
        sessionStorage.setItem("UtType", response.data.Data.UtType);

        toast.success("Login Successfully", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          onClose: () => {
            navigate("/dashboard");
          },
        });
      } else {
        setIsLoading(false);
        toast.error("Login failed: " + response.data.Message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } catch (error) {
      setIsLoading(false);
      toast.error("An error occurred during login.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const handleLoginMethodChange = (method) => {
    setLoginMethod(method);
    if (!keepMeLoggedIn) {
      setUserId("");
      setPassword("");
      setNumber("");
    }
  };

  return (
    <Box className="main_login">
      <ToastContainer />
      <Container container className="main_container">
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="center"
          className="middle_container"
        >
          <Grid item xs={12} md={6}>
            <Box display="flex" flexDirection="column" justifyContent="center">
              <img
                src={logo}
                alt="logo"
                className="loginLogo"
                style={{ width: "100%", maxWidth: "200px" }}
              />
              <Typography
                variant="h4"
                gutterBottom
                className="mb-4"
                sx={{
                  fontSize: { xs: "18px", sm: "20px", md: "25px" },
                  marginTop: "10px",
                }}
              >
                Welcome to Clanbridge !
              </Typography>
              <Typography variant="h6" gutterBottom className="mb-4">
                Let's get you signed in
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={6}>
                  <Button
                    startIcon={<AssignmentIndIcon />}
                    className={`buttons ${loginMethod === "userId" ? "active" : ""
                      }`}
                    fullWidth
                    sx={{
                      marginBottom: 2,
                      height: "75%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() => handleLoginMethodChange("userId")}
                  >
                    Login with UserName
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <Button
                    startIcon={<PhoneAndroidIcon />}
                    className={`buttons ${loginMethod === "mobile" ? "active" : ""
                      }`}
                    fullWidth
                    sx={{
                      marginBottom: 2,
                      height: "75%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() => handleLoginMethodChange("mobile")}
                  >
                    Resident Login
                  </Button>
                </Grid>
              </Grid>
              {loginMethod === "userId" ? (
                <>
                  <Typography
                    variant="subtitle1"
                    style={{
                      fontWeight: 550,
                      color: "#29343d",
                      fontSize: "15px",
                      marginBottom: "5px",
                    }}
                  >
                    User Name
                  </Typography>
                  <TextField
                    type="text"
                    variant="outlined"
                    placeholder="Enter your username"
                    fullWidth
                    className="input_form"
                    value={userId}
                    InputProps={{
                      style: {
                        height: "40px",
                      },
                    }}
                    sx={{
                      "& .MuiOutlinedInput-input": {
                        paddingTop: "8px",
                        paddingBottom: "8px",
                      },
                    }}
                    onChange={handleUserIdChange} // Updated handler
                  />
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Typography
                      variant="subtitle1"
                      style={{
                        fontWeight: 550,
                        color: "#29343d",
                        fontSize: "15px",
                        marginTop: "12px",
                        paddingBottom: "5px",
                      }}
                    >
                      Password
                    </Typography>
                  </Box>
                  <TextField
                    type={showPassword ? "text" : "password"}
                    variant="outlined"
                    placeholder="Enter your password"
                    fullWidth
                    className="input_form "
                    sx={{
                      "& .MuiOutlinedInput-input": {
                        paddingTop: "8px",
                        paddingBottom: "8px",
                      },
                    }}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        handleLogin();
                      }
                    }}
                    // InputProps={{
                    //   style: {
                    //     height: "40px",
                    //   },
                    //   endAdornment: (
                    //     <Button
                    //       sx={{
                    //         paddingLeft: '66px'
                    //       }}
                    //       onClick={() => setShowPassword(!showPassword)}>
                    //       {showPassword ? <Visibility /> : <VisibilityOff />}
                    //     </Button>
                    //   ),
                    // }}
                    InputProps={{
                      style: {
                        height: "40px",
                      },
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                            {showNewPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </>
              ) : (
                <>
                  <Typography
                    variant="subtitle1"
                    style={{
                      fontWeight: 550,
                      color: "#29343d",
                      fontSize: "15px",
                      marginBottom: "5px",
                    }}
                  >
                    Mobile Number
                  </Typography>
                  <TextField
                    type="text"
                    variant="outlined"
                    placeholder="Enter your Number"
                    fullWidth
                    className="input_form"
                    value={number}
                    onChange={handleMobileInputChange}
                    error={!isMobileValid}
                    helperText={
                      !isMobileValid ? (
                        <Box display="flex" alignItems="center">
                          {email ? (
                            <>
                              <Typography
                                variant="body2"
                                style={{ marginRight: "8px" }}
                              >
                                {message === "New User"
                                  ? "New User"
                                  : "Unauthorized User..."}
                              </Typography>
                              {/* Show the Create Password link only if Pwd is null and RoomBedId has a value */}
                              {residentData &&
                                !residentData.Pwd &&
                                residentData.RoomBedId && (
                                  <Link
                                    onClick={handleValidateMobile}
                                    sx={{
                                      cursor: "pointer",
                                      color: "blue",
                                      textDecoration: "underline",
                                    }}
                                  >
                                    Create Password
                                  </Link>
                                )}
                            </>
                          ) : (
                            <Typography
                              variant="body2"
                              style={{ marginRight: "8px" }}
                            >
                              Invalid user...
                            </Typography>
                          )}
                        </Box>
                      ) : (
                        ""
                      )
                    }
                    InputProps={{
                      classes: {
                        input: "custom-placeholder",
                      }, style: {
                        height: "40px",
                      },
                      endAdornment: (
                        <>
                          {isMobileValid &&
                            residentData &&
                            residentData.Pwd &&
                            residentData.RoomBedId &&
                            number.length === 10 && (
                              <CheckCircleIcon
                                sx={{ color: "green", marginLeft: 1 }}
                              />
                            )}
                        </>
                      ),
                    }}
                    sx={{
                      backgroundColor: "#f5f5f5",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: "rgba(0, 0, 0, 0.87)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "rgba(0, 0, 0, 0.87)",
                        },
                        "& input": {
                          backgroundColor: "#f5f5f5",
                          padding: "10px",
                          margin: 0,
                          width: "100%",
                        },
                      },
                    }}
                  />

                  <Typography
                    variant="subtitle1"
                    style={{
                      fontWeight: 550,
                      color: "#29343d",
                      fontSize: "15px",
                      marginTop: "12px",
                      paddingBottom: "5px",
                    }}
                  >
                    Password
                  </Typography>
                  <TextField
                    type={showResidentPwd ? "text" : "password"}
                    variant="outlined"
                    placeholder="Enter Your password"
                    fullWidth
                    className="input_form"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        handleMobileLogin();
                      }
                    }}
                    InputProps={{
                      classes: {
                        input: "custom-placeholder",
                      },
                      style: {
                        height: "40px",
                      },
                      endAdornment: (
                        <Button
                          sx={{
                            paddingLeft: '76px'
                          }}
                          onClick={() => setShowResidentPwd(!showResidentPwd)}
                        >
                          {showResidentPwd ? <Visibility /> : <VisibilityOff />}
                        </Button>
                      ),
                    }}
                  />
                </>
              )}

              <Box
                className="py-2"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Box display="flex" alignItems="center">
                  <Checkbox size="small"
                    className="check_box"
                    checked={keepMeLoggedIn}
                    onChange={handleKeepMeLoggedInChange}
                  />
                  <Typography
                    variant="body2"
                    className="mx-2"
                    sx={{
                      fontSize: {
                        xs: "12px",
                        sm: "14px",
                        md: "16px",
                        lg: "16px",
                      },
                      ml: 1
                    }}
                  >
                    Keep me logged in
                  </Typography>
                  <Link
                    onClick={
                      loginMethod === "userId" ? handleToggleInputModal : handleToggleForgotModal
                    }
                    variant="contained"
                    className="forgot_pass"
                    style={{ cursor: "pointer", marginLeft: "10px" }}
                  >
                    Forgot Password?
                  </Link>
                </Box>
              </Box>
              <Button
                onClick={
                  loginMethod === "userId" ? handleLogin : handleMobileLogin
                }
                className="button_signin"
                variant="contained"
                fullWidth
                style={{ marginTop: 16 }}
              >
                {isLoading ? "Please Wait..." : "Sign In"}
              </Button>
              <Typography
                variant="body2"
                sx={{
                  marginTop: 2,
                  fontSize: {
                    xs: "0.8rem",
                    sm: "1rem",
                  },
                }}
              >
                By Clicking Sign In, you agree to our <Link component="button"
                  onClick={() => navigate('/legal')}
                  sx={{
                    color: '#667eea',
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    '&:hover': { color: '#764ba2' }
                  }}>Terms & Conditions
                  </Link>{" "} of Clanbridge Living Pvt. Ltd.,{" "}
                
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={6} style={{ textAlign: "center" }}
            sx={{
              display: { xs: "none", md: "block" },
            }}
          >
            <Box
              component="img"
              src={hostel2}
              alt="Feature Rich 3D Charts"
              style={{
                width: "350px",
                height: "318px",
                marginTop: "87px",
                borderRadius: "25px",
              }}
            />
          </Grid>
        </Grid>
      </Container>

      <OtpModal
        isModalOpen={isModalOpen}
        handleCloseModal={handleCloseModal}
        email={email}
        otp={otp}
        setOtp={setOtp}
        generatedOtp={generatedOtp}
        isOtpVerified={isOtpVerified}
        setIsOtpVerified={setIsOtpVerified}
        isOtpMismatch={isOtpMismatch}
        setIsOtpMismatch={setIsOtpMismatch}
        newPassword={newPassword}
        setNewPassword={setNewPassword}
        confirmPassword={confirmPassword}
        setConfirmPassword={setConfirmPassword}
        passwordError={passwordError}
        checkPasswordMatch={checkPasswordMatch}
        handleCreatePassword={handleCreatePassword}
        setVerifiedMobileNumber={setVerifiedMobileNumber}
        number={number}
        setIsOtpSent={setIsOtpSent}
      />

      <ForgotPasswordModal
        isModalFgtOpen={isModalFgtOpen}
        handleCloseFgtModal={handleCloseFgtModal}
        email={email}
        otp={otp}
        setOtp={setOtp}
        generatedFgtOtp={generatedFgtOtp}
        isOtpVerified={isOtpVerified}
        setIsOtpVerified={setIsOtpVerified}
        isOtpMismatch={isOtpMismatch}
        setIsOtpMismatch={setIsOtpMismatch}
        newPassword={newPassword}
        setNewPassword={setNewPassword}
        confirmPassword={confirmPassword}
        setConfirmPassword={setConfirmPassword}
        passwordError={passwordError}
        checkPasswordMatch={checkPasswordMatch}
        handleCreateNewPwd={handleCreateNewPwd}
        setVerifiedMobileNumber={setVerifiedMobileNumber}
        number={number}
        setIsOtpSent={setIsOtpSent}
      />

      <InputMobileModal
        isModalInputMobileOpen={isInputMobModalOpen}
        handleCloseInputMobileModal={handleCloseInputMobModal}
        handleChange={handleMobileInputChange}
        error={!isMobileValid}
        mobileNo={number}
        helperText={
          !isMobileValid ? (
            <Box display="flex" alignItems="center">
              {email ? (
                <>
                  <Typography
                    variant="body2"
                    style={{ marginRight: "8px" }}
                  >
                    {message === "New User"
                      ? "New User"
                      : "Unauthorized User..."}
                  </Typography>
                  {/* Show the Create Password link only if Pwd is null and RoomBedId has a value */}
                  {residentData &&
                    !residentData.Pwd &&
                    residentData.RoomBedId && (
                      <Link
                        onClick={handleValidateMobile}
                        sx={{
                          cursor: "pointer",
                          color: "blue",
                          textDecoration: "underline",
                        }}
                      >
                        Create Password
                      </Link>
                    )}
                </>
              ) : (
                <Typography
                  variant="body2"
                  style={{ marginRight: "8px" }}
                >
                  Invalid user...
                </Typography>
              )}
            </Box>
          ) : (
            ""
          )
        }
        InputProps={{
          classes: {
            input: "custom-placeholder",
          }, style: {
            height: "40px",
          },
          endAdornment: (
            <>
              {isMobileValid &&
                residentData &&
                residentData.Pwd &&
                residentData.RoomBedId &&
                number.length === 10 && (
                  <CheckCircleIcon
                    sx={{ color: "green", marginLeft: 1 }}
                  />
                )}
            </>
          ),
        }}
        sx={{
          backgroundColor: "#f5f5f5",
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "rgba(0, 0, 0, 0.23)",
            },
            "&:hover fieldset": {
              borderColor: "rgba(0, 0, 0, 0.87)",
            },
            "&.Mui-focused fieldset": {
              borderColor: "rgba(0, 0, 0, 0.87)",
            },
            "& input": {
              backgroundColor: "#f5f5f5",
              padding: "10px",
              margin: 0,
              width: "100%",
            },
          },
        }}
      />
    </Box>
  );
};

export default Login;